// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueDND from 'awe-dnd'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import TableColumnSetting from './components/TableColumnSetting/index.vue'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueDND)
Vue.use(Viewer)
Vue.component('TableColumnSetting', TableColumnSetting)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js